import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeftIcon } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const t = params.get("token");
    if (t) setToken(t);
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirmPw) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password reset. Please log in.");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-white">
      <form onSubmit={submit} className="w-full max-w-sm space-y-8" data-testid="reset-form">
        <Link to="/login" className="flex items-center text-xs uppercase tracking-wider text-slate-500 hover:text-slate-900">
          <ArrowLeftIcon size={12} className="mr-1" /> Back to login
        </Link>
        <div>
          <div className="overline mb-3">Reset password</div>
          <h2 className="font-display text-3xl font-bold">Set a new password</h2>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="overline">Reset token</Label>
            <Input
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              className="rounded-none h-11 font-mono-num"
              data-testid="reset-token-input"
            />
          </div>
          <div>
            <Label className="overline">New password</Label>
            <Input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              required
              minLength={6}
              className="rounded-none h-11"
              data-testid="reset-pw-input"
            />
          </div>
          <div>
            <Label className="overline">Confirm password</Label>
            <Input
              type="password"
              value={confirmPw}
              onChange={(e) => setConfirmPw(e.target.value)}
              required
              minLength={6}
              className="rounded-none h-11"
              data-testid="reset-confirm-input"
            />
          </div>
        </div>
        <Button
          type="submit"
          disabled={busy}
          className="w-full h-11 rounded-none bg-slate-900 hover:bg-black text-white"
          data-testid="reset-submit-button"
        >
          {busy ? "Resetting…" : "Reset password"}
        </Button>
      </form>
    </div>
  );
}
